import { Docs } from "@pcgerente-node/pcg-comun";
import { CIUDAD, CLIENTE, USUARIO_CLIENTE, logistica_CONTENIDO, logistica_GUIA_PROFORMA, logistica_MANIFIESTO_PROFORMA_DETALLE, logistica_RANGO_GUIA, logistica_RANGO_SEGURO } from "@pcgerente-node/pcg-comun/dist/DTOs";
import { PayloadAction } from "@reduxjs/toolkit";
import axios, { AxiosResponse } from "axios";
import { logistica_GUIA_PROFORMALocal } from "../../components/Entidades/logistica_GUIA_PROFORMA";
import {IApiResponse} from "@pcgerente-node/pcg-comun";
import { baseURL, establecerEstado, handleResponse, headers, limpiarEstado, reestablecerEstado, seteaError, structureInfoState } from "../helpersRedux";
import { setCiudadesCrear, setCiudadesDestino, setCiudadesOrigen, setContenidoGuia, setDestinatario, setGuiaPrevisualizar, setGuiaProformaImprimir, setGuiasProformaDB, setRangoGuia, setRangosSegurosPorDefecto, setRemitente, setimprimirManifiestoProforma } from "../slices/crearSlice";


//Numero Guia
export const obtenerRangoGuiaDelUsuario = (idUsuario: number, idDocumento: Docs.GUIA_TRANSPORTE) => 
async (dispatch:(action: PayloadAction<structureInfoState<logistica_RANGO_GUIA>>) => void) => {
  try{
    dispatch(setRangoGuia(limpiarEstado(new logistica_RANGO_GUIA)))
    const response =  await axios(`${baseURL}logistica_RANGO_GUIA?idUsuario=${idUsuario}&idDocumento=${idDocumento}`,headers)
    .then((res:AxiosResponse<IApiResponse<logistica_RANGO_GUIA>>) => handleResponse(res))
      dispatch(setRangoGuia(establecerEstado(response)))
  }catch(error){
    if(error instanceof Error){
      dispatch(setRangoGuia(seteaError(error, new logistica_RANGO_GUIA())))
    } 
  }
};


//MANIFIESTO_PROFORMA (usado para imprimir)
export const getManifiestoDetails = (idManifiesto: number ) => 
async (dispatch:(action: PayloadAction<structureInfoState<logistica_MANIFIESTO_PROFORMA_DETALLE[]>>) => void) => {
    dispatch(setimprimirManifiestoProforma(reestablecerEstado()))
  try{
    let response = await axios.get(`${baseURL}logistica_MANIFIESTO_PROFORMA/Detalles/${idManifiesto}`, headers)
    .then((res: AxiosResponse<IApiResponse<logistica_MANIFIESTO_PROFORMA_DETALLE[]>>) => handleResponse(res))
    dispatch(setimprimirManifiestoProforma(establecerEstado(response)))
  }
  catch(error){
    if(error instanceof Error){
      dispatch(setimprimirManifiestoProforma(seteaError(error)))
    }
  }
}

//previsualizar
export const getGuiaProformaParaImprimir = (serie1: string, serie2: string, numeroDocumento: number) => 
  async (dispatch:(action: PayloadAction<structureInfoState<logistica_GUIA_PROFORMA>>) => void) => {
  try {
      dispatch(setGuiaProformaImprimir(limpiarEstado(new logistica_GUIA_PROFORMA)))
      const response =  await axios.get(`${baseURL}logistica_GUIA_PROFORMA?serie1=${serie1}&serie2=${serie2}&numeroDocumento=${numeroDocumento}`, headers)
      .then((res: AxiosResponse<IApiResponse<logistica_GUIA_PROFORMA[]>>) => handleResponse(res))

      dispatch(setGuiaProformaImprimir(establecerEstado(response[0])))   
  } catch (error) {
    if(error instanceof Error){
      dispatch(setGuiaProformaImprimir(seteaError(error, new logistica_GUIA_PROFORMA())))
    }      
  }
}


export const saveGuiaPrevisualizar = (guia: logistica_GUIA_PROFORMALocal ) => 
  (dispatch:(action: PayloadAction<structureInfoState<logistica_GUIA_PROFORMALocal>>) => void) => {
    dispatch(setGuiaPrevisualizar(establecerEstado(guia)))
}

export const clearGuiaPrevisualizar = () =>
  (dispatch:(action: PayloadAction<structureInfoState<logistica_GUIA_PROFORMALocal>>) => void) => {
    dispatch(setGuiaPrevisualizar(limpiarEstado(new logistica_GUIA_PROFORMALocal)))
}

//Guias Proforma
export const obtenerGuiasProformasLiberadas= (desde: string, hasta:string, idUsuario: number) =>
async (dispatch:(action: PayloadAction<structureInfoState<logistica_GUIA_PROFORMA[]>>) => void) => {
  try{
    dispatch(setGuiasProformaDB(limpiarEstado()))
    let response = await axios.get(`${baseURL}logistica_GUIA_PROFORMA?&idUsuario=${idUsuario}&desde=${desde}&hasta=${hasta}`, headers)
    .then((res: AxiosResponse<IApiResponse<logistica_GUIA_PROFORMA[]>>) => handleResponse(res))
    dispatch(setGuiasProformaDB(establecerEstado(response)))
  }
  catch(error){
    if (error instanceof Error){
      dispatch(setGuiasProformaDB(seteaError(error)))
    }
  }
}

export const obtenerRangosSeguroPorDefecto = () =>async (dispatch:(action: PayloadAction<structureInfoState<logistica_RANGO_SEGURO[]>>) => void) => {
  try{
    dispatch(setRangosSegurosPorDefecto(limpiarEstado()))
    let response = await axios.get(`${baseURL}logistica_RANGO_SEGURO/porDefecto`, headers)
    .then((res: AxiosResponse<IApiResponse<logistica_RANGO_SEGURO[]>>) => handleResponse(res))
    dispatch(setRangosSegurosPorDefecto(establecerEstado(response)))
  }
  catch(error){
    if (error instanceof Error){
      dispatch(setRangosSegurosPorDefecto(seteaError(error)))
    }
  }
}


//ciudades
export const getAllCities = () =>
  async (dispatch:(action: PayloadAction<structureInfoState<CIUDAD[]>>) => void) => {
    dispatch(setCiudadesCrear(limpiarEstado()))
    try{
      const response = await axios.get(`${baseURL}CIUDAD`, headers)
      .then((res: AxiosResponse<IApiResponse<CIUDAD[]>>) => handleResponse(res))
      dispatch(setCiudadesCrear(establecerEstado(response)))
    }
    catch(error){
      if (error instanceof Error){
        dispatch(setCiudadesCrear(seteaError(error)))
      }
    }
};


//remitente
export const getInfoRemitentes= (idUsuario: number) => 
  async (dispatch:(action: PayloadAction<structureInfoState<USUARIO_CLIENTE[]>>) => void) => {
    clearInfoRemitente()
    try{
      const response =  await axios(`${baseURL}USUARIO/${idUsuario}/USUARIO_CLIENTE/`, headers)
      .then((res:AxiosResponse<IApiResponse<USUARIO_CLIENTE[]>>) => handleResponse(res))
      dispatch(setRemitente(establecerEstado(response)))
    }
    catch(error){
      if(error instanceof Error)
        dispatch(setRemitente(seteaError(error)))
    }
}

export const clearInfoRemitente = () =>
async (dispatch:(action: PayloadAction<structureInfoState<USUARIO_CLIENTE[]>>) => void) => {
    dispatch(setRemitente(reestablecerEstado()))
}

//ciudades Origen Remitente
export const getCiudadesOrigenRemitente = (idCliente: number ) => 
async (dispatch:(action: PayloadAction<structureInfoState<CIUDAD[]>>) => void) => {
  try{
    const response =  await axios(`${baseURL}CLIENTE/${idCliente}/logistica_CONTENIDO/CIUDAD_ORIGEN/`, headers)
      .then((res:AxiosResponse<IApiResponse<CIUDAD[]>>) => handleResponse(res))
    dispatch(setCiudadesOrigen(establecerEstado(response)))
  }
  catch{
    dispatch(setCiudadesOrigen(limpiarEstado()))
  }
}

export const getCiudadesDestinoDestinatario = (idCliente: number, idCiudadOrigen: number ) => 
async (dispatch:(action: PayloadAction<structureInfoState<CIUDAD[]>>) => void) => {
  try{
    const response =  await axios(`${baseURL}CLIENTE/${idCliente}/logistica_CONTENIDO/CIUDAD_ORIGEN/?idCiudadOrigen=${idCiudadOrigen}`, headers)
      .then((res:AxiosResponse<IApiResponse<CIUDAD[]>>) => handleResponse(res))
    dispatch(setCiudadesDestino(establecerEstado(response)))
  }catch(error){
    if(error instanceof Error)
      dispatch(setCiudadesDestino(seteaError(error)))
  }
}

//destinatario
export const getInfoDestinatario= (cedulaCliente: string) => 
  async (dispatch:(action: PayloadAction<structureInfoState<CLIENTE>>) => void) => {
    try{
      const response =  await axios(`${baseURL}CLIENTE?identificacion=${cedulaCliente}&direccionProforma=${true}`, headers)
       .then((res:AxiosResponse<IApiResponse<CLIENTE[]>>) => handleResponse(res))
       if(response.length != 1){ 
        throw new Error("No se encontró un registro válido")
       }else{
         dispatch(setDestinatario(establecerEstado(response[0])))
      }
    }catch(error){
        dispatch(setDestinatario(establecerEstado(new CLIENTE())))
    }
}

export const clearInfoDestinatario= () => 
  async (dispatch:(action: PayloadAction<structureInfoState<CLIENTE>>) => void) => {
    dispatch(setDestinatario(limpiarEstado(new CLIENTE())))
}


//Contenido disponibles (guia)
export const getProductosDisponibles = ( idCliente: number, idCiudadOrigen: number, idCiudadDestino: number ) => 
async (dispatch:(action: PayloadAction<structureInfoState<logistica_CONTENIDO[]>>) => void) => {
  try{
    const response =  await axios(`${baseURL}CLIENTE/${idCliente}/logistica_CONTENIDO?idCiudadOrigen=${idCiudadOrigen}&idCiudadDestino=${idCiudadDestino}`, headers)
      .then((res:AxiosResponse<IApiResponse<logistica_CONTENIDO[]>>) => handleResponse(res))
     dispatch(setContenidoGuia(establecerEstado(response)))
  }catch(error){
    if(error instanceof Error)
      dispatch(setContenidoGuia(seteaError(error)))
  }
}

export const clearProductosDisponibles= () => 
async (dispatch:(action: PayloadAction<structureInfoState<logistica_CONTENIDO[]>>) => void) => {
     dispatch(setContenidoGuia(limpiarEstado()))
}

//limpiar estados
export const limpiarCrearSlice = () => 
  async (dispatch:(action: PayloadAction<structureInfoState<logistica_GUIA_PROFORMA| CLIENTE| CIUDAD[] | USUARIO_CLIENTE[] | logistica_GUIA_PROFORMA[] |logistica_MANIFIESTO_PROFORMA_DETALLE[]| logistica_CONTENIDO[]|logistica_RANGO_GUIA>|logistica_GUIA_PROFORMA> ) => void) => {
    dispatch(setRangoGuia(reestablecerEstado(new logistica_RANGO_GUIA())))
    dispatch(setGuiaPrevisualizar(reestablecerEstado(new logistica_GUIA_PROFORMALocal())))
    dispatch(setCiudadesCrear(reestablecerEstado()))
    dispatch(setRemitente(reestablecerEstado()))
    dispatch(setCiudadesOrigen(reestablecerEstado()))
    dispatch(setCiudadesDestino(reestablecerEstado()))
    dispatch(setDestinatario(reestablecerEstado(new CLIENTE())))
    dispatch(setGuiasProformaDB(reestablecerEstado()))
    dispatch(setGuiaProformaImprimir(reestablecerEstado(new logistica_GUIA_PROFORMA())))
    dispatch(setimprimirManifiestoProforma(reestablecerEstado()))
    dispatch(setContenidoGuia(reestablecerEstado()))
}

//Helpers
